import React, { useState } from "react";
import { Form, Button, Switch } from "antd";

const FormToggleButton = ({
  name,
  label,
  buttonLabel = "Toggle",
  initialValue = false,
  onChange,
  disabled = false,
  required = false,
  tooltip,
  className = "",
  standalone = false, 
  value, 
}) => {
  const [standaloneValue, setStandaloneValue] = useState(initialValue);

  // Standalone mode (non-form)
  if (standalone) {
    const isActive = value !== undefined ? value : standaloneValue;

    return (
      <div className={className}>
        {label && <span className="mr-2">{label}</span>}
        <Button
          type=""
          onClick={() => {
            if (disabled) return;
            const newValue = !isActive;
            if (value === undefined) {
              setStandaloneValue(newValue);
            }
            onChange?.(newValue);
          }}
          className={`mr-2 min-w-[104px] h-[30px] px-[10px] font-medium !bg-[#E9E9E9] border !text-customColor ${
            disabled ? "cursor-not-allowed" : ""
          }`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            pointerEvents: disabled ? "none" : "auto",
          }}
        >
          <Switch
            checked={isActive}
            size="small"
            disabled={disabled}
            className="pointer-events-none custom-handle-switch"
            style={{
              border: "1px solid rgba(255, 255, 255, 0.8)",
            }}
          />
          <span>{buttonLabel}</span>
        </Button>
      </div>
    );
  }

  // Form mode (original behavior)
  return (
    <Form.Item
      name={name}
      label={label}
      valuePropName="checked"
      initialValue={initialValue}
      tooltip={tooltip}
      rules={
        required ? [{ required: true, message: `Please toggle ${label}` }] : []
      }
      className={className}
    >
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue, setFieldsValue }) => {
          const isActive = getFieldValue(name);

          return (
            <Button
              type=""
              onClick={() => {
                if (disabled) return;
                const newValue = !isActive;
                setFieldsValue({ [name]: newValue });
                onChange?.(newValue);
              }}
              className={`mr-2 min-w-[104px] h-[30px] px-[10px] font-medium !bg-[#E9E9E9] border !text-customColor ${
                disabled ? "cursor-not-allowed" : ""
              }`}
              style={{
                display: "inline-flex",
                alignItems: "center",
                pointerEvents: disabled ? "none" : "auto",
              }}
            >
              <Switch
                checked={isActive}
                size="small"
                disabled={disabled}
                className="pointer-events-none custom-handle-switch"
                style={{
                  border: "1px solid rgba(255, 255, 255, 0.8)",
                }}
              />
              <span>{buttonLabel}</span>
            </Button>
          );
        }}
      </Form.Item>
    </Form.Item>
  );
};

export default FormToggleButton;
